module.exports = __webpack_public_path__ + "img/360int-white.d35fa6ac.svg";